import React from "react";
import { styled, Stack, Box, Button } from "@mui/material";

export interface TopbarProps {
  options: {
    label: string;
    value: string;
    subOptions?: { label: string; value: string }[];
  }[];
  isLoggedIn?: boolean;
  handleAction: (type: string) => void;
  handleClick: (value: string) => void;
  selected?: string;
  showBackgroundColor?: boolean;
  onClick?: () => void;
}

const CustomNavigation = styled(Stack)(({ theme }: any) => ({
  position: "relative",
  "&:hover": {
    background: theme.palette.common.backgroundBlack,
    color: theme.palette.common.primary,
    "& .navigation-content": {
      display: "flex",
    },
  },
  "& .navigation-content": {
    display: "none",
    position: "absolute",
    backgroundColor: theme.palette.common.backgroundBlack,
    zIndex: 1,
    top: 49,
    left: 0,
    borderRadius: 0,
    flexDirection: "column",
    minWidth: 135,
  },
}));

const CustomButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isSelected",
  name: "Button",
})<{ isSelected?: boolean; theme?: any }>(({ isSelected, theme }) => ({
  padding: "0px 20px !important",
  borderRadius: 0,
  background: isSelected && theme.palette.common.backgroundBlack,
  color: isSelected && theme.palette.common.primary,
  fontSize: 14,
  "&:hover": {
    background: theme.palette.common.backgroundBlack,
    color: theme.palette.common.primary,
  },
}));
const SubButton = styled(Button)(({ theme }: any) => ({
  padding: "0px 20px !important",
  borderRadius: 0,
  fontSize: 14,
  width: "100%",
  "&:hover": {
    color: theme.palette.common.primary,
    background: theme.palette.common.backgroundBlack,
  },
}));

const Topbar = ({
  options,
  isLoggedIn,
  handleAction,
  handleClick,
  selected,
  showBackgroundColor,
  onClick,
}: TopbarProps) => {
  return (
    <Stack
      alignItems="center"
      className={showBackgroundColor ? "background-blackLight" : undefined}
      p={2}
    >
      <Stack width="80%" direction="row">
        <Box onClick={onClick} style={{ cursor: "pointer" }}>
          <img src="/assets/logo.png" alt="logo" />
        </Box>
        <Stack
          flex={1}
          justifyContent="flex-end"
          direction="row"
          spacing={1}
          alignItems="center"
        >
          {options.map((option: any) => {
            return (
              <CustomNavigation>
                <CustomButton
                  sx={{ textTransform: "uppercase" }}
                  onClick={() => { if (!option.subOptions) handleClick(option.value) }}
                  isSelected={selected?.includes(option.value)}
                  disableTouchRipple
                >
                  {option.label}
                  {option.subOptions && option.subOptions.length > 0 && (
                    <i
                      className="far fa-chevron-down icon-sm font-white"
                      style={{ marginLeft: 8 }}
                    />
                  )}
                </CustomButton>
                {option.subOptions && option.subOptions.length > 0 && (
                  <Box className="navigation-content">
                    {option.subOptions.map((item: any) => (
                      <SubButton onClick={() => handleClick(item.value)} sx={{ textTransform: "uppercase", justifyContent:"flex-start" }}>
                        {item.label}
                      </SubButton>
                    ))}
                  </Box>
                )}
              </CustomNavigation>
            );
          })}
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleAction(isLoggedIn ? "log-out" : "log-in")}
          >
            {isLoggedIn ? "Log Out" : "Log In"}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
export default Topbar;
